export const EnumOther = {
  /** @name 云学堂 页面 */
  other_yxt: 'https://openapi.yunxuetang.cn/login/sso',
  other_xiaozhi: 'https://scsupport.lenovo.com.cn/lcicsp/new-pc/lenovoit/',
  other_xiaozhi_tst: 'https://sc-tst.lenovo.com.cn/lcicsp/new-pc/lenovoit/',
};
